import React from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {tabletAndUp} from '../../../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../../constants/typography';
import {RichText} from '../../../../atoms/Text';

interface DeliverySectionHeaderProps {
  headline: string;
  deliveryDate?: string;
  hightlightDateLabel?: boolean;
  shippedBy?: string;
}

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const DeliverySectionHeader: React.FC<DeliverySectionHeaderProps> = ({
  headline,
  deliveryDate,
  hightlightDateLabel,
  shippedBy,
}) => {
  return (
    <HeaderSection data-testid="deliveryHeaderSection">
      <HeadlineWrapper>
        <Headline data-testid="deliveryHeadline">{headline}</Headline>
        {shippedBy && (
          <RichText
            size="px10"
            color="Grey0"
            data-testid="shippedByMerchantInfo"
          >
            {shippedBy}
          </RichText>
        )}
      </HeadlineWrapper>
      <div>
        {deliveryDate && (
          <ArrivalDate
            data-testid="deliveryDate"
            $highlightBackground={hightlightDateLabel}
          >
            {deliveryDate}
          </ArrivalDate>
        )}
      </div>
    </HeaderSection>
  );
};

const HeadlineWrapper = styled.div`
  flex-direction: column;
  display: flex;
  gap: 0.375rem;
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: top;
  padding-inline: 16px;

  ${tabletAndUp(
    css`
      padding-inline: 24px;
    `,
  )}
`;

const Headline = styled.div`
  font-size: ${FONT_SIZES.px16};
  color: ${COLORS.Black};
  font-weight: ${FONT_WEIGHTS.bold};
`;

const ArrivalDate = styled.div<{$highlightBackground?: boolean}>`
  padding: 6px 12px;
  border-radius: 16px;
  background-color: ${({$highlightBackground}) =>
    $highlightBackground ? COLORS.GreenNeon : COLORS.Grey4};
  font-size: ${FONT_SIZES.px14};
  color: ${({$highlightBackground}) =>
    $highlightBackground ? COLORS.DarkGreen : 'inherit'};
`;
